import clsx from 'clsx';
import { useViewport } from 'hooks/3catinfo/useViewport';
import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import CercaMunicipi from 'components/3catinfo/CercaMunicipi';
import styles from './destacatTendenciesClimatiques.module.scss';
import stylesCerca from './cercaTendenciaMunicipi.module.scss';
import municipis from './tendencia_municipis.json';

const DestacatTendenciesClimatiques = (props) => {
    const {
        titol = 'El canvi climàtic al teu municipi',
        subtitol = "Consulta com t'impactarà fins al 2050 si seguim com fins ara.",
        label = 'Cerca un municipi',
        explora = true,
        estil
    } = props;
    const { zoomNavigator, isOnlyMobile } = useViewport();

    const getImatge = () => {
        const src = isOnlyMobile
            ? '/_resources/imatges/3catinfo/crisi-climatica.jpg?v=JIT_ENV_RESOURCES_VERSION'
            : '/_resources/imatges/3catinfo/crisi-climatica.png?v=JIT_ENV_RESOURCES_VERSION';
        return estil !== 'basic' ? (
            <div className={styles.wrapperImg}>
                <div className={styles.imgRodona}>
                    <Imatge src={src} layout='fill' className={styles.bg} mostrarRecursTitol={false} objectFit='cover' alt='' />
                </div>
            </div>
        ) : (
            <></>
        );
    };

    const stylesWrrapper = clsx({
        [styles.wrapperTendencies]: true,
        [styles.basic]: estil === 'basic',
        [styles.ambZoom]: zoomNavigator > 2.5,
        [styles.ambZoom400]: zoomNavigator > 3
    });

    return (
        <div className={stylesWrrapper}>
            <div className={styles.contentInfo}>
                <div className={styles.innerWrapper}>
                    <div className={styles.content}>
                        <div className={styles.header}>
                            <h2>{titol}</h2>
                            <p className={styles.subtitol}>{subtitol}</p>
                        </div>
                        <div className={styles.contentCaixaCerca}>
                            <CercaMunicipi
                                placeholder={label}
                                styles={stylesCerca}
                                estilIcon='taronja'
                                routePath='web_3catinfo_tendencies_climatiques_municipi'
                                getTitle={(item) => `Tendencia climàtica a ${item.nom}`}
                                municipisList={municipis?.municipis}
                            />
                        </div>
                        {explora && (
                            <div className={styles.exploraTxt}>
                                Explora escenaris futurs a:{' '}
                                <ul className={styles.enllacos}>
                                    <li>
                                        <Enllac
                                            type='web_3catinfo_estatiques_subseccio'
                                            slug='tendencies-climatiques'
                                            slug2='tendencies-catalunya'
                                            className={styles.enllac}
                                        >
                                            Catalunya
                                        </Enllac>{' '}
                                    </li>
                                    <li>
                                        <Enllac
                                            type='web_3catinfo_estatiques_subseccio'
                                            slug='tendencies-climatiques'
                                            slug2='tendencies-mediterrani'
                                            className={styles.enllac}
                                        >
                                            Mediterrani
                                        </Enllac>{' '}
                                    </li>
                                    <li>
                                        <Enllac
                                            type='web_3catinfo_estatiques_subseccio'
                                            slug='tendencies-climatiques'
                                            slug2='tendencies-mon'
                                            className={styles.enllac}
                                        >
                                            Món
                                        </Enllac>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {getImatge()}
        </div>
    );
};

export default DestacatTendenciesClimatiques;
